import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { setTeamSettingSidebarExpanded } from "../../../actions/teamSettingSidebar";
import { number } from "../../../config";
import ProjectSettings from "../../ProjectSidebar/ProjectSidebarContent/ProjectSidebarSections/ProjectSettings";
import ProjectStagesGrid from "../../ProjectSidebar/ProjectSidebarContent/ProjectSidebarSections/ProjectStagesGrid/ProjectStagesGrid";
import TeamActivityLog from "../TeamActivityLog/TeamActivityLog";
import { TEAM_SETTING_SECTION_IDS, TEAM_SETTING_DEFAULT_EXPANDED } from "./teamSettingSidebar.constants";
import "./TeamSettingSidebarContent.scss";
import ProjectConfigurationsSection from "./ProjectConfigurationsSection";

/**
 * TeamSettingSidebarContent component handles the content for the team setting sidebar.
 * @author Bhavana
 */
const TeamSettingSidebarContent = () => {
  const dispatch = useDispatch();
  const expanded = useSelector((state) => state.teamSettingSidebar?.expanded) ?? TEAM_SETTING_DEFAULT_EXPANDED;
  const { projectDetails } = useSelector((state) => state.projectSidebar);

  const [, setIsProjectCode] = useState(true);
  
  const projectId = useMemo(() => projectDetails?.ProjectId, [projectDetails?.ProjectId]);
  const isProjectCodeEmpty = useCallback((projectCode) => {
    setIsProjectCode(projectCode?.length >= number.FOUR);
  }, []);

  useEffect(() => {
    dispatch(setTeamSettingSidebarExpanded(TEAM_SETTING_DEFAULT_EXPANDED));
  }, [projectId]);

  const handleSelect = (event) => {
    if (event.expandedItems) {
      dispatch(setTeamSettingSidebarExpanded(event.expandedItems));
    }
  };

  const panelTitle = (text) => (
    <div className="panelbar-item-title d-flex align-items-center justify-content-between w-100 font-weight-medium">{text}</div>
  );

  return (
    <div className="team-setting-sidebar-content">
      <PanelBar
        isControlled={true}
        expanded={expanded}
        onSelect={handleSelect}
        expandMode="multiple"
        className="team-setting-panelbar">
        <PanelBarItem
          id={TEAM_SETTING_SECTION_IDS.PROJECT_INFORMATION}
          title={panelTitle("Project Information")}
          className="team-setting-panelbar-item">
          <div className="team-setting-section-anchor px-3 pb-2">
            <ProjectSettings isProjectCodeEmpty={isProjectCodeEmpty} />
          </div>
        </PanelBarItem>
        <PanelBarItem
          id={TEAM_SETTING_SECTION_IDS.PROJECT_CONFIGURATION}
          title={panelTitle("Project Configurations")}
          className="team-setting-panelbar-item">
          <div className="team-setting-section-anchor px-3 pb-3">
           <ProjectConfigurationsSection />
          </div>
        </PanelBarItem>
        <PanelBarItem
          id={TEAM_SETTING_SECTION_IDS.PROJECT_STAGES}
          title={panelTitle("Project Stages")}
          className="team-setting-panelbar-item">
          <div className="team-setting-section-anchor px-3 pb-2">
            <ProjectStagesGrid projectId={projectDetails?.ProjectId} />
          </div>
        </PanelBarItem>
        <PanelBarItem id={TEAM_SETTING_SECTION_IDS.LOGS} title={panelTitle("Logs")} className="team-setting-panelbar-item">
          <div className="team-setting-section-anchor team-setting-logs-wrap px-3 pb-2">
            <TeamActivityLog projectId={projectId} />
          </div>
        </PanelBarItem>
      </PanelBar>
    </div>
  );
};

export default TeamSettingSidebarContent;
